import React from 'react';
import { useSelector } from 'react-redux';
import Scrollbar from 'react-smooth-scrollbar';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import SidebarContent from './SidebarContent';
import useClientMenuData from './useClientMenuData';
import { SidebarProps } from '../../../shared/prop-types/ReducerProps';

const Sidebar = ({
  changeToDark, changeToLight, changeToLimitless, changeDevPlatform, changeMobileSidebarVisibility, sidebar,
}) => {
  const seller = useSelector(state => state.sellerSelect);
  const clientMenuData = useClientMenuData(seller);
  const sidebarClass = classNames({
    sidebar: true,
    'sidebar--show': sidebar.show,
    'sidebar--collapse': sidebar.collapse,
  });

  return (
    <div className={sidebarClass}>
      <button type="button" className="sidebar__back" onClick={() => changeMobileSidebarVisibility()} />
      <Scrollbar className="sidebar__scroll scroll">
        <div className="sidebar__wrapper sidebar__wrapper--desktop">
          <SidebarContent
            sidebar={sidebar}
            onClickGutter={() => {}}
            changeToDark={changeToDark}
            changeToLight={changeToLight}
            changeToLimitless={changeToLimitless}
            changeDevPlatform={changeDevPlatform}
            clientMenuData={clientMenuData}
          />
        </div>
        <div className="sidebar__wrapper sidebar__wrapper--mobile">
          <SidebarContent
            onClickGutter={() => changeMobileSidebarVisibility()}
            sidebar={sidebar}
            changeToDark={changeToDark}
            changeToLight={changeToLight}
            changeToLimitless={changeToLimitless}
            changeDevPlatform={changeDevPlatform}
            clientMenuData={clientMenuData}
          />
        </div>
      </Scrollbar>
    </div>
  );
};

Sidebar.propTypes = {
  sidebar: SidebarProps.isRequired,
  changeToDark: PropTypes.func.isRequired,
  changeToLight: PropTypes.func.isRequired,
  changeToLimitless: PropTypes.func.isRequired,
  changeDevPlatform: PropTypes.func.isRequired,
  changeMobileSidebarVisibility: PropTypes.func.isRequired,
};

export default Sidebar;
